// Framework Dependencies
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Module Dependencies
import { MitsTourPositionDaysComponent } from './mits-tour-position-days.component';
import { MitsIconModule } from 'src/packages/shared-ui';
import { MitsObjectSelectModule } from 'src/packages/shared-ui';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, MitsIconModule, MitsObjectSelectModule],
  declarations: [MitsTourPositionDaysComponent],
  entryComponents: [MitsTourPositionDaysComponent],
  exports: [MitsTourPositionDaysComponent],
  providers: []
})
export class MitsTourPositionDaysModule {
}
